import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBracketsCurly12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconBracketsCurly12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#BracketsCurly12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M6.996.473a.5.5 0 0 0 .464.526l.928 1.037A3.7 3.7 0 0 1 8.5 3c0 1.608.657 2.517 1.401 3.002C9.157 6.485 8.5 7.393 8.5 9c0 1.098-.331 1.572-.568 1.779a1 1 0 0 1-.431.22l-.016.002a.5.5 0 0 0 .068.998l-.03-.499.031.5.001-.001h.006l.01-.001a1 1 0 0 0 .103-.014q.093-.015.238-.06c.19-.064.436-.18.68-.393.501-.44.908-1.216.908-2.531 0-1.332.536-1.914 1.002-2.194a2.2 2.2 0 0 1 .977-.301h.011-.002a.5.5 0 0 0 .004-1L9.509 3.288l1.983 2.215h-.011l-.056-.004a2.2 2.2 0 0 1-.922-.3c-.432-.262-.923-.782-.994-1.911l-1.12-1.253 1.12 1.252A5 5 0 0 1 9.5 3c0-1.32-.416-2.098-.927-2.536a2 2 0 0 0-.689-.39A1.7 1.7 0 0 0 7.54.003h-.01L7.526 0h-.002l-.029.5.027-.5a.5.5 0 0 0-.527.473m1.392 1.563L7.46 1h.017a1 1 0 0 1 .445.221c.154.133.347.373.466.814M4.988.473A.5.5 0 0 1 4.507 1a1 1 0 0 0-.445.221c-.154.133-.347.373-.466.814L2.475 3.288q.009-.138.009-.288c0-1.32.416-2.098.926-2.536.248-.213.498-.327.69-.39a1.7 1.7 0 0 1 .344-.072h.01L4.458 0h.002l.028.5-.027-.5a.5.5 0 0 1 .527.473M2.475 3.289.492 5.503M2.475 3.29.492 5.504m0 0h.01L.56 5.5a2.2 2.2 0 0 0 .922-.3c.431-.262.922-.782.994-1.911l1.12-1.253A3.7 3.7 0 0 0 3.485 3c0 1.608-.658 2.517-1.401 3.002.744.483 1.4 1.391 1.4 2.998 0 1.098.332 1.572.568 1.779a1 1 0 0 0 .432.22l.016.002a.5.5 0 0 1-.07.999l.03-.499-.03.5L4.429 12h-.006l-.01-.001a1 1 0 0 1-.103-.014 2 2 0 0 1-.238-.06 2 2 0 0 1-.68-.393c-.501-.44-.908-1.216-.908-2.531 0-1.332-.536-1.914-1.002-2.194a2.2 2.2 0 0 0-.978-.301h-.01.001a.5.5 0 0 1-.003-1m0 0h.002zm3.104-3.469L4.524 1z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="BracketsCurly12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconBracketsCurly12);
